module.exports = __webpack_public_path__ + "img/rir.a590b4e0.svg";